import * as React from 'react';
import classnames from 'classnames';
import * as ReactDOM from 'react-dom';
import * as Models from './models';

import './options-modal.scss'

function Modal<T, V extends Models.ItemValue>(props: Modal.Props<T, V>) {
	if (!props.show) return null;

	const getItemText = (option: Object) => {
		if (props.itemTemplate) return this.props.itemTemplate(option);

		if (option.hasOwnProperty('itemText')) return (option as Models.Option<T, V>).itemText;

		if (option) return option.toString();
		return 'null';
	};

	const generateOptionPosition = (className: string): { className: string; style: React.CSSProperties } => {
		var containerRect = props.containerRect;
		var coordinates = {
			top: containerRect.top + containerRect.height,
			bottom: null as number,
			left: containerRect.left,
			width: containerRect.width - 2,
			maxHeight: 200,
		};
		if (coordinates.top + coordinates.maxHeight > window.innerHeight) {
			coordinates.top = null;
			coordinates.bottom = window.innerHeight - containerRect.top;
		}
		if (coordinates.width < 100) {
			coordinates.left -= 50;
			coordinates.width += 100;
		}
		return {
			className: classnames(className),
			style: {
				position: 'absolute',
				...coordinates,
			},
		};
	};

	return ReactDOM.createPortal(
		<div className={classnames('options-host')} onClick={() => props.onHideOptions()}>
			<div {...generateOptionPosition(classnames('option-host-content'))}>
				<div className='option-list' onClick={e => e.stopPropagation()}>
					<ul className={classnames('r-select-options')}>
						{props.options.map((option, index) => (
							<li
								title={getItemText(option)}
								key={index}
								className={classnames('r-select-option', {
									'r-select-option-selected': props.isSelected(option),
								})}
								onMouseDown={() => props.onChange(option)}
							>
								{getItemText(option)}
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>,
		document.body
	);
}

namespace Modal {
	export interface Props<T, V extends Models.ItemValue> {
		options: Models.Option<T, V>[];
		show: boolean;
		classNames?: string | string[];
		onBlackoutClick?: () => void;
		children?: React.ReactElement;
		renderContent?(): React.ReactElement;
		onHideOptions?: () => void;
		itemTemplate?: React.ReactElement;
		onChange: (data: Models.Option<T, V>) => void;
		containerRect?: ClientRect;
		isSelected?: (data: Models.Option<T, V>) => boolean;
	}
}

export default Modal;
